import * as React from 'react';
import { Spinner } from '../Spinner/Spinner';

export interface ISendButtonProps {
  isSending: boolean;
  sendDisabled: boolean;
  classNames?: string;
  hideTextOnSending?: boolean;
  onClickSave: (e: React.MouseEvent) => void;
  isSaving?: boolean;
  savingLabel?: string;
}

export default class SendButton extends React.PureComponent<ISendButtonProps> {
  public render() {
    const { onClickSave, isSending, sendDisabled, hideTextOnSending, isSaving = false, savingLabel } = this.props;
    const buttonDisabled = sendDisabled || isSending || isSaving;
    const sendingText = hideTextOnSending ? ' ' : 'Skickar';
    const isSavingText = savingLabel ?? 'Sparar';
    const showSpinner = isSending || isSaving;

    return (
      <div>
        <button
          className={this.props.classNames ?? 'button'}
          disabled={buttonDisabled}
          onClick={onClickSave}
          aria-live="polite"
          aria-busy={showSpinner}>
          {showSpinner && (
            <div className="flex-center">
              <Spinner />
              {isSending && <span>{sendingText}</span>}
              {!isSending && <span className="sr-only">{isSavingText}</span>}
            </div>
          )}
          {!showSpinner && <span>Skicka in</span>}
        </button>
      </div>
    );
  }
}
